import { ServiceResponse } from "./ServiceResponse";

export class LastUpdatedResponse extends ServiceResponse {
  public LastUpdated: Date | null = null;
}
